<template>
	<div>
		<v-tabs
			align-with-title
			right
			slider-color="#00add4"
			class="mt-3"
			v-model="active"
		>
			<v-tab
				v-for="tab in tabs"
				:key="tab.id"
				active-class="cyan--text"
			>
				<span class="caption font-weight-bold">{{ tab.name }}</span>
			</v-tab>
			<v-tabs-items v-model="active">
				<modulesCardList
					:columns="columns"
					:current-page="params.page"
					:last-page="table.lastPage"
					:rows="table.rows"
					@on-page="changePage"
					@on-search="onSearchDictionary"
				/>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>

<script>
	import modulesCardList from '@/components/definitions-ats/modules-list-ats';

	function active() {
		this.params.page = 1;
		this.loadDictionary();
	}

	function moduleId(val) {
		if (val) {
			this.loadDictionary();
		}
	}

	async function changePage(page) {
		this.params.page = page;
		await this.loadDictionary.call(this);
	}

	async function loadDictionary() {
		this.$set(this.params, 'moduleId', this.moduleId);
		this.$set(this.params, 'dataType', this.active + 1);
		this.$set(this.params, 'limit', this.limit);
		const { records } = await this.loadData('data-dictionary-transactional');
		this.rows = records.map(({ id, code, description, example, name, subsidiaryModuleId }) =>
			({ code, description, example, name, id, subsidiaryModuleId }),
		);
		return this.rows;
	}

	function onSearchDictionary(search) {
		this.params.page = 1;
		this.$set(this.params, 'search', search);
		this.loadDictionary();
	}

	function data() {
		return {
			active: 0,
			rows: [],
			limit: 10,
			lastPage: 0,
		};
	}

	export default {
		name: 'modules-card-ats',
		components: {
			modulesCardList,
		},
		data,
		methods: {
			loadDictionary,
			onSearchDictionary,
			changePage,
		},
		props: {
			columns: {
				default: () => [],
				type: Array,
			},
			moduleId: [Number, String],
			tabs: {
				default: () => [],
				type: Array,
			},
		},
		watch: {
			active,
			moduleId,
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/definitions-ats/modules-card-ats.vue